import { module } from 'modujs';
import { gsap } from "gsap";

export default class extends module {
    constructor(m) {
        super(m);

        this.autoplay = this.el.hasAttribute('data-logo-autoplay');
        this.logo = this.el.querySelector('.c-logo');
        this.line1 = this.logo.querySelector('.c-logo_line1');
        this.line2 = this.logo.querySelector('.c-logo_line2');
        this.line3 = this.logo.querySelector('.c-logo_line3');

        this.tl = null;
    }

    init() {
        this.tl = gsap.timeline({
            repeat: -1, repeatDelay: 0.5,
            paused: !this.autoplay
        });
        
        let tlPulse = gsap.timeline({ repeat: 1 });
        tlPulse.fromTo(
            this.logo,
            { scale: 1, rotate: 0 },
            { scale: 1.1, rotate: 2, duration: 0.2, ease: 'power1' }
        )
        tlPulse.fromTo(
            this.logo,
            { scale: 1.1, rotate: 2 },
            { scale: 1, rotate: 0, duration: 0.2, ease: 'power1' }
        )
        this.tl.add(tlPulse);

        this.tl.addLabel('letters', '+=0.2');

        this.tl.fromTo(
            this.line1.querySelectorAll('.c-logo_letter'),
            { y: '105%', scaleX: 0.1, transformOrigin: 'top center' },
            { y: 0, scaleX: 1, scaleY: 1, ease: 'elastic.out(1,0.45)', duration: 1.2, stagger: { amount: 0.25, from: 'random' } },
            'letters'
        );
        this.tl.fromTo(
            this.line2.querySelectorAll('.c-logo_letter'),
            { y: '105%', scaleX: 0.1, transformOrigin: 'top center' },
            { y: 0, scaleX: 1, scaleY: 1, ease: 'elastic.out(1,0.45)', duration: 1.2, delay: 0.3, stagger: { amount: 0.25, from: 'random' } },
            'letters'
        );
        this.tl.fromTo(
            this.line3.querySelectorAll('.c-logo_letter'),
            { y: '105%', scaleX: 0.1, transformOrigin: 'top center' },
            { y: 0, scaleX: 1, scaleY: 1, ease: 'elastic.out(1,0.45)', duration: 1.2, delay: 0.6, stagger: { amount: 0.25, from: 'random' } },
            'letters'
        );
        this.tl.fromTo(
            this.line3.querySelectorAll('.c-logo_dot'),
            { y: 50, scaleX: 0, transformOrigin: 'top center' },
            { y: 0, scaleX: 1, ease: 'elastic.out(1,0.45)', duration: 1.2 },
            "-=1"
        );

        this.tl.addLabel('hide', '+=1');

        this.tl.to(
            this.el.querySelectorAll('.c-logo_letter'),
            { y: '105%', ease: 'power4.out', duration: 0.4, stagger: { amount: 0.2, from: 'random' } },
            'hide'
        );
        this.tl.to(
            this.el.querySelectorAll('.c-logo_dot'),
            { y: 50, ease: 'power4.out', duration: 0.4 },
            'hide'
        );
    }

    play() {
        this.tl.play();
    }

    pause() {
        this.tl.pause();
    }

    toggle(e){
        if (e.way == 'enter') {
            this.play();
        } else {
            this.pause();
        }
    }

}
